module.exports = "<app-navbar></app-navbar>\n<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main